import { Locale } from '@ps-smart-cp/ppfw-client';

const autoJudgeBasisConfig = {
  leaseAccountBasis: new Map([
    [Locale.ja, 'リース会計'],
    [Locale.en, 'Lease Account'],
  ]),
  taxBasis: new Map([
    [Locale.ja, '税務'],
    [Locale.en, 'Tax'],
  ]),
  ifrsBasis: new Map([
    [Locale.ja, 'IFRS'],
    [Locale.en, 'IFRS'],
  ]),
};

export { autoJudgeBasisConfig };
